import { render, staticRenderFns } from "./ExpelledAcademicVacationIndex.vue?vue&type=template&id=136fa7a0"
import script from "./ExpelledAcademicVacationIndex.vue?vue&type=script&lang=js"
export * from "./ExpelledAcademicVacationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports